import React, { Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "@revvsales/components";

// Internal Imports
import { DOCUMENTS, COMMON } from "../../../constants";
// import { DOCUMENTVIEW_MODE } from "../constants";

// Destructing
const { DOCUMENT_COMPONENT_TYPES } = DOCUMENTS;
// const { DOCUMENTVIEW, FORMVIEW } = DOCUMENTVIEW_MODE;

const { DEAL_LABELS } = COMMON;

class OutlineItem extends React.Component {
  state = {
    edit: false,
    label: this.props.outlineItem ? this.props.outlineItem.label : "",
  };

  componentDidUpdate(prevProps) {
    if (prevProps.outlineItem && this.props.outlineItem) {
      if (prevProps.outlineItem.label !== this.props.outlineItem.label) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({ label: this.props.outlineItem.label });
      }
    }
  }

  _editLabel = () => {
    this.nameInput.focus();
    this.setState({ edit: true });
  };

  _updateLabel = event => {
    this.setState({ label: event.target.value });
  };

  _updateOutlineLabel = () => {
    if (!this.props.editable) {
      return;
    }
    this.setState({ edit: false });
    if (this.state.label !== this.props.outlineItem.label) {
      this.props.updateOutlineLabel(
        this.props.outlineItem.id,
        this.state.label,
      );
    }
  };

  _getValue = label => {
    switch (label) {
      case "Deal Table":
        return DEAL_LABELS["deal-table-label"];
      case "Deal Table Placeholder":
        return `${DEAL_LABELS["deal-table-label"]} Placeholder`;
      default:
        return label;
    }
  };

  _handleClick = outlineItemID => {
    const component = document.getElementById(outlineItemID);
    if (component !== null) {
      component.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
      component.className += " active-component ";
    } else {
      console.debug("component not found");
    }
  };

  _outlineItemView = () => {
    const { outlineItem } = this.props;
    const isItemEditable = !!(
      this.props.editable &&
      (outlineItem && outlineItem.allowEdit) &&
      this.state.edit
    );
    const className = `item-header ${this.state.editable ? "active" : ""}`;
    // Note :: commented out for now, but need it later
    // const enableDragDrop = !!(
    //   this.props.isDocumentView && !this.props.lockDragnDrop
    // );
    return (
      <li key={outlineItem.id} className="component-item-view">
        <div
          className="header-item"
          data-test="documentheaderitem-outline-component-item-header"
          // Note :: commented out for now, but need it later
          // draggable={enableDragDrop}
          // onDrag={enableDragDrop ? this.props.onDrag : undefined}
          // onDragStart={
          //   enableDragDrop
          //     ? event =>
          //         this.props.onDragStart(
          //           event,
          //           outlineItem.id,
          //           this.state.label,
          //         )
          //     : undefined
          // }
          // onDragEnd={enableDragDrop ? this.props.onDragEnd : undefined}
        >
          <div
            data-test="documentheaderitem-leftsidebar-component-item"
            className="component-item"
            // Note :: commented out for now, but need it later
            // onDragEnter={
            //   enableDragDrop
            //     ? event => this.props.onDragEnter(event, outlineItem.id)
            //     : undefined
            // }
            // onDragOver={
            //   enableDragDrop
            //     ? event => this.props.onDragOver(event, outlineItem.id)
            //     : undefined
            // }
            // onDrop={
            //   enableDragDrop
            //     ? event => this.props.onDrop(event, outlineItem.id)
            //     : undefined
            // }
            // onDragLeave={event => event.stopPropagation()}
          >
            {/* ----------- Header List Item In Case Of Document View ----------- */}
            {this.props.isDocumentView && (
              <Fragment>
                {/* ----------- Drag Icon Section ----------- */}
                {(this.props.isSharedDocument || !this.props.lockDragnDrop) && (
                  <i
                    className="ic-drag"
                    data-test="documentheaderitem-outline-component-drag-icon">
                    <FontAwesomeIcon icon={["far", "bars"]} />
                  </i>
                )}
                {/* ----------- Deal/Quote Table Icon Section ----------- */}
                {(outlineItem.type === "DealTable" ||
                  outlineItem.type === "QuoteTable") && (
                  <i
                    data-test="documentheaderitem-ic-dealtable-link-leftsidebar-dealtable-component"
                    className="ic-deal-link">
                    <FontAwesomeIcon icon={["far", "link"]} />
                  </i>
                )}
                <input
                  className={className}
                  data-test="documentheaderitem-outline-component-item-header"
                  placeholder={this.state.label}
                  ref={input => {
                    this.nameInput = input;
                  }}
                  value={this._getValue(this.state.label)}
                  onClick={() => this._handleClick(outlineItem.id)}
                  readOnly={!isItemEditable}
                  onChange={isItemEditable ? this._updateLabel : undefined}
                  onBlur={isItemEditable ? this._updateOutlineLabel : undefined}
                  onDoubleClick={
                    this.props.editable && outlineItem.allowEdit
                      ? this._editLabel
                      : undefined
                  }
                />
              </Fragment>
            )}

            {/* ----------- Header List Item In Case Of Form View ----------- */}
            {this.props.isDocumentFormView && (
              <Fragment>
                {/* <span>{this.props.seqNo}.</span> */}
                <input
                  className={className}
                  placeholder={this.state.label}
                  ref={input => {
                    this.nameInput = input;
                  }}
                  value={this.state.label}
                  onClick={() => this._handleClick(outlineItem.id)}
                  readOnly
                />
              </Fragment>
            )}
          </div>
        </div>
        {/* ----------- Edit Label Icon Section ----------- */}
        {this.props.editable &&
          outlineItem.allowEdit &&
          this.props.isDocumentView &&
          !isItemEditable && (
            <span
              className="btn-icon ic-edit-component"
              data-test="documentheaderitem-outline-component-rename-edit-icon"
              onClick={this._editLabel}
              onKeyDown={() => {}}
              role="button"
              tabIndex={0}>
              <Tooltip
                placement="top"
                overlay="Rename block"
                align={{
                  offset: [0, 5],
                }}>
                <i>
                  <FontAwesomeIcon icon={["far", "pen-square"]} />
                </i>
              </Tooltip>
            </span>
          )}
      </li>
    );
  };

  /**    Note :: commented out for now, need it later
   * :: _dropOutlineItemView :: this view is being used here to
   *    show the drop placeholder of dragged outline item
   */
  // _dropOutlineItemView = () => {
  //   const { outlineItem, draggedSection } = this.props;
  //   if (!this.props.lockDragnDrop && this.props.draggedOver && draggedSection) {
  //     return (
  //       <li key={`dragged-${draggedSection.id}`}>
  //         <div className="drop-section">
  //           <div
  //             className="component-item"
  //             onDragEnter={event =>
  //               this.props.onDragEnter(event, outlineItem.id)
  //             }
  //             onDragOver={event => this.props.onDragOver(event, outlineItem.id)}
  //             onDrop={event => this.props.onDrop(event, outlineItem.id)}>
  //             <div>
  //               <i>
  //                 <FontAwesomeIcon icon={["far", "bars"]} />
  //               </i>
  //             </div>
  //             <input
  //               className="item-header"
  //               value={draggedSection.label}
  //               readOnly
  //             />
  //           </div>
  //         </div>
  //       </li>
  //     );
  //   }
  //   return null;
  // };

  render() {
    if (this.props.outlineItem) {
      // const outlineListItem = [
      //   this._outlineItemView(),
      //   this._dropOutlineItemView(),
      // ];
      return this._outlineItemView();
    }

    return null;
  }
}

const mapStateToProps = (state, props) => {
  const { components } = state.DocumentStore;
  let outlineItem = null;
  if (props.item) {
    if (props.isDocumentView) {
      const { id, type } = props.item;
      if (type === DOCUMENT_COMPONENT_TYPES.COVERPAGE) {
        const component = components[id];
        if (
          component &&
          component.content &&
          component.content.data &&
          component.content.data.attributes &&
          component.content.data.attributes.isOpen
        ) {
          outlineItem = {
            id,
            label: "CoverPage",
            allowEdit: false,
          };
        }
      } else if (type === DOCUMENT_COMPONENT_TYPES.HEADER) {
        outlineItem = {
          id: `document-header-${id}`,
          label: "Header",
          allowEdit: false,
        };
      } else if (type === DOCUMENT_COMPONENT_TYPES.FOOTER) {
        outlineItem = {
          id: `document-footer-${id}`,
          label: "Footer",
          allowEdit: false,
        };
      } else if (type === "BODY") {
        const component = components[id];
        if (component && component.content) {
          outlineItem = {
            id,
            label: component.content.label,
            type: component.content.type,
            allowEdit: true,
          };
        }
      }
    } else if (props.isDocumentFormView) {
      outlineItem = props.item;
    }
  }
  return { outlineItem };
};

export default connect(mapStateToProps)(OutlineItem);



// WEBPACK FOOTER //
// ./src/components/DocumentV2/Outline/OutlineItem.js